import { ApiRequest } from 'app/common/types'

interface GetMatchedTreatmentCountsGetContent {
  audienceId: string
  fromDate: string
  toDate: string
}

export type GetMatchedTreatmentCountsGetRequest = ApiRequest<GetMatchedTreatmentCountsGetContent>

export type ConversionsPerTreatments = Record<string, number>

interface GetMatchedTreatmentCounts {
  conversions: number
  conversionsPerTreatments: { total: number } & ConversionsPerTreatments
}

export interface GetMatchedTreatmentCountsGetResponse {
  data: GetMatchedTreatmentCounts
}

export const mapConversions = (
  matchedTreatmentCounts: GetMatchedTreatmentCounts,
): ConversionsPerTreatments => {
  const { total: _, ...conversionsPerTreatments } = matchedTreatmentCounts.conversionsPerTreatments

  return conversionsPerTreatments
}
